import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {GoDotFill} from 'react-icons/go'
import {Link} from 'react-router-dom'
import {ClassroomSvg} from 'components/Svgs/ClassroomSvg'

// Banner "nền của lớp" (gradient indigo + họa tiết ClassroomSvg) - DÙNG CHUNG cho mọi nơi hiển thị
// "chi tiết 1 lớp học" (tên/mã lớp/giảng viên/sĩ số/môn học): trước đây CourseClassDetail.js (trang
// đầy đủ, có nút "quay lại khóa" đứng NGOÀI banner này - không phải nội dung banner nên không đưa vào
// đây) tự vẽ banner màu, còn CourseClassPanelDetail.js (popup "Chi tiết lớp học" mở từ danh sách lớp)
// lại có 1 khối trắng đơn giản riêng, thiếu hẳn danh sách môn học - 2 nơi cùng 1 khái niệm nhưng lệch
// UI (bạn báo). Giờ quy về 1 component, cả 2 nơi cùng nhận diện + cùng đủ thông tin.
// teacherLabel: ưu tiên coordinator (người phụ trách lớp, gán tay) - CHỈ fallback dedicated_teacher
// (BE tự suy khi lớp có ĐÚNG 1 môn học + ĐÚNG 1 giảng viên dạy qua thời khoá biểu,
// CourseClassTransformer::getDedicatedSubjectTeacher) khi lớp CHƯA gán coordinator, tránh hiện trùng
// 2 dòng "Giảng viên :" nếu cả 2 đều có (đúng logic đã có sẵn ở 2 nơi trước khi gộp).
// showCourseTitle: khối trắng cũ ở CourseClassPanelDetail.js (popup, KHÔNG có breadcrumb "quay lại
// khóa" như trang CourseClassDetail.js) có hiện tên khóa ngay trong khối - giữ lại thông tin này qua
// prop tùy chọn thay vì âm thầm bỏ mất khi gộp, CourseClassDetail.js không truyền vì tên khóa đã có ở
// breadcrumb riêng ngoài banner (xem chỗ gọi).
export const ClassInfoBanner = ({item, showCourseTitle = false}) => {
    const t = useTranslate()
    const coordinators = item?.coordinators ?? []
    const firstCoordinator = coordinators[0]
    const teacherLabel = firstCoordinator?.teacher_name || (item?.dedicated_teacher ? getTitle(item.dedicated_teacher) : null)
    const class_subjects = item?.class_subjects ?? []
    const courseTitle = showCourseTitle ? getTitle(item?.course) : null

    return (
        <div
            className="relative overflow-hidden p-4 shadow-lg rounded-xl transition-all duration-300"
            style={{background: 'linear-gradient(90deg, rgb(51 89 125) 0%, rgb(0 74 135) 100%)'}}>
            <ClassroomSvg
                size={128}
                className="absolute -right-5 -bottom-8 text-white opacity-10 pointer-events-none"
            />
            <div className="relative">
                <Link to={getLinkToDetail(item)} className="no-underline">
                    <h1 className="text-2xl font-bold space-x-1 leading-snug text-white">
                        <span className="underline">{t('course_class')}:</span>
                        <span>{item?.title}</span>
                    </h1>
                </Link>
                <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs" style={{color: '#cbd5e1'}}>
                    {item?.course_class_idcode && (
                        <span className="px-2 py-0.5 font-mono font-semibold text-white bg-white-20 rounded-full tracking-wider">
                            #{item.course_class_idcode}
                        </span>
                    )}
                    {courseTitle && (
                        <span className="flex items-center gap-1">
                            <GoDotFill size={6} className="text-white-40"/>
                            {courseTitle}
                        </span>
                    )}
                    {(firstCoordinator || item?.dedicated_teacher) && (
                        <span className="flex items-center gap-1">
                            <GoDotFill size={6} className="text-white-40"/>
                            {`${t('teacher')} :`}
                            <span className="font-semibold text-white tracking-wider">
                                {teacherLabel}
                            </span>
                        </span>
                    )}
                    <span className="flex items-center gap-1">
                        <GoDotFill size={6} className="text-white-40"/>
                        <span className="text-white">
                            <label className="font-bold">
                                {item?.number_of_students ?? 0}
                            </label> {t('student').toLowerCase()}
                        </span>
                    </span>
                    {class_subjects.length > 0 && (
                        <span className="flex items-center flex-wrap gap-1">
                            <GoDotFill size={6} className="text-white-40"/>
                            {class_subjects.map((cs, i) => (
                                <span key={i} className="font-medium text-white tracking-wider">
                                    {getTitle(cs.subject ?? cs)}
                                    {i < class_subjects.length - 1 && <span style={{color: '#cbd5e1'}}>,</span>}
                                </span>
                            ))}
                        </span>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ClassInfoBanner
